import { useEffect, useState } from 'react'
import { Modal } from 'shared/components/modal'
import { JSONFetcher, DISHtml } from 'shared'
import { DonateButton } from 'ppp'
import classNames from 'classnames'

import wirWunderLogo from '../../assets/images/logos/wirwunder_logo.svg'

export const MatchingEventNotice = (props) => {
  const [matchingEvent, setMatchingEvent] = useState()

  const [show, setShow] = useState(false)
  const onHide = () => setShow(false)

  const handleClick = () => {
    setShow(true)
    document.activeElement.blur()
  }

  useEffect(() => {
    JSONFetcher.load({
      url: props.matchingEventUrl,
      success: (event) => {
        setMatchingEvent(event)
      }
    })
  }, [])

  if (!matchingEvent) return null

  return (
    <div className='m-b-sm p-a-sm rounded-lg' style={{ backgroundColor: matchingEvent.backgroundColor, color: matchingEvent.color}}>
      <div className='row'>
        <div className="col-8 d-flex align-items-center justify-content-center">
          <img src={matchingEvent.logo || wirWunderLogo} alt='' style={{ maxWidth: '90%', flexShrink: 0 }}/>
        </div>
        <div className="col-16 p-l-xs" >
          <p className='mb-0'>
            <DISHtml value={matchingEvent.bannerContent}/>
            <br/>
            <a onClick={handleClick} style={{ fontWeight: 'normal' }}><u>{I18n.t('projects.show.stats.matching_event.banner_read_more')}</u></a>
            </p>
        </div>
        <Modal
          show={show}
          onHide={onHide}
          content={
            <ModalContent
              matchingEvent={matchingEvent}
              project={props.project}
              status={props.status}
              onHide={onHide}
            />
          }
          header={matchingEvent.modalHeadline}
        />
      </div>
    </div>
  )
}

const ModalContent = (props) => {
  const { backgroundColor, logo, modalDuration, modalBudget, modalMaximumAmount, modalFurtherInfo, branchLogo } = props.matchingEvent

  return (
    <>
      <div className={classNames('d-flex text-center text-white align-items-center', logo ? 'justify-around' : 'justify-between')} style={{backgroundColor: backgroundColor}}>
        <img className='ml-3 py-3 flex-grow-0 flex-shrink-1' src={logo || wirWunderLogo} alt='' style={{ maxHeight: '80px', maxWidth: '45%' }} />
        {!logo && <img className='mr-3 flex-grow-0 flex-shrink-1' src={branchLogo} alt='' style={{ maxHeight: '80px', maxWidth: '45%' }} />}
      </div>
      <div className='my-3'>
        <p>
          <DISHtml value={modalDuration} />
        </p>
        <p>
          <DISHtml value={modalBudget} />
        </p>
        <p>
          <DISHtml value={modalMaximumAmount} />
        </p>
        <p className='my-4'>
          <DISHtml value={modalFurtherInfo} />
        </p>
      </div>
      <div className='d-flex justify-content-between'>
        <button type="button" className="simulated-link" onClick={props.onHide} >{I18n.t('misc.close')}</button>
        {!props.project.donations_prohibited && <DonateButton
          project={props.project}
          status={props.status}
          additionalClass='btn-large'
          gaAction='click donate_button__matching_event'
        />}
      </div>
    </>
  )
}
